// Components
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import organizationFields from '../../../fields/organizationFields';


export const columnsEnvelopesClientsId = 'envelopesClients';
export const columnsEnvelopesClients = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsEnvelopesClientsId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: organizationFields.LEGAL_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: organizationFields.BUSINESS_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: organizationFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: organizationFields.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity nowrap
                    entity={`${organizationFields.TYPE.prefix}${cell.getValue(organizationFields.TYPE.key)}`}
                    namespace={organizationFields.TYPE.namespace}
                />
            )
        }),
        generateColumnDefByField({
            field: organizationFields.PORTS,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: organizationFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(organizationFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: organizationFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(organizationFields.UPDATED_AT.key)} />
            )
        })
    ]).filter(col => !!col);
};